import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { Link as RouterLink } from 'react-router-dom';
import {
  TextField,
  Card,
  CardContent,
  Button,
  CardActions,
} from '@material-ui/core';

import styles from './styles';
import useStyles from '../shared/useStyles';

import Logo from '../shared/logo';
import { loginGuest } from '../../store/actions/user.action';
import { validateEmail } from '../../core/validate';

const LoginPage = () => {
  const loginError = useSelector((state) => state.app.status.login.error);
  const classes = useStyles(styles);
  const [emailInput, setEmailInput] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [cardRased, setCardRased] = useState(false);
  const dispatch = useDispatch();

  const handleEmail = (e) => {
    const value = e.target.value;

    setEmailInput(value);
  };

  const checkEmailEnter = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();

      submit();
    }
  };

  const submit = () => {
    const isEmailValid = validateEmail(emailInput);

    setEmailError(!isEmailValid);

    if (!isEmailValid) return;

    dispatch(loginGuest(emailInput));
  };

  return (
    <div className={classes.loginContainer}>
      <Card
        className={classes.loginCard}
        raised={cardRased}
        onFocus={() => setCardRased(true)}
        onBlur={() => setCardRased(false)}
      >
        <CardContent className={classes.loginContent}>
          <Logo className={classes.loginLogo} />

          <TextField
            error={emailError}
            helperText={emailError ? 'Invalid email' : ''}
            required
            variant="outlined"
            label="Email"
            type="email"
            autoComplete="email"
            className={classes.inputItem}
            value={emailInput}
            onChange={handleEmail}
            onKeyDown={checkEmailEnter}
          />
        </CardContent>
        <CardActions className={classes.loginActions}>
          <Button
            variant="contained"
            color="primary"
            onClick={submit}
            disabled={!emailInput}
          >
            Next
          </Button>
        </CardActions>
      </Card>
    </div>
  );
};
export default LoginPage;
